import { EmptyState, Page } from "../components/ui";

function NoAccess() {
  return (
    <Page style={{ margin: "0 auto", paddingTop: "15vh" }}>
      <EmptyState
        title={<h1 style={{ fontSize: "22px", margin: 0 }}>Unauthorised</h1>}
      >
        You do not currently have access to Sidekick.
      </EmptyState>
    </Page>
  );
}

export default NoAccess;
